import BaseClient from '@/app/model/api/response/baseTriartApiClient'

class TriartApi extends BaseClient {
  public findField (sensorKey: string, companyId: string) {
    const path = '/fp/find_field'
    const url = new URL(process.env.VUE_APP_TRIART_API_URL + path)
    const params = new URLSearchParams({ public: 'true', pointid: sensorKey, spwscid: companyId })
    url.search = params.toString()

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new TriartApi()
